import { Box, Typography, useTheme } from '@mui/material'
import { ClockCounterClockwise } from '@phosphor-icons/react'
import { FormattedMessage } from 'react-intl'

const Header = () => {
  const theme = useTheme()
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      padding={1}
      marginTop={-1}
      sx={{ backgroundColor: theme.colours.baseExtraLight, borderRadius: theme.display.borderRadiusSmall }}
    >
      <ClockCounterClockwise size={16} weight="bold" color={theme.colours.new.grey2} />
      <Typography
        fontSize={theme.typography.pxToRem(12)}
        color={theme.colours.new.grey2}
        fontWeight={theme.typography.fontWeightBold}
        textTransform="uppercase"
      >
        <FormattedMessage id="cases.recentlyViewedCases" />
      </Typography>
    </Box>
  )
}

export default Header
